import Utils from "./Utils";


export default class Enums {

    static get APP_TITLE() {
        return 'Vitec Autodata Web';
    }




    static readonly AuthorizedTransactionPostToJavaAPI = ['VAVE'];

    // State
    static readonly DRAWER_WITH = 340;
    //
    static readonly uVisning = ['Totalsalg', 'Kunde', 'Varegruppe', 'Hovedgruppe', 'Gruppe', 'Summeringsgruppe',
        'Kundekategori', 'Handelsdistrikt', 'Ordremottaker', 'Selger'];
    //
    static readonly kVisning = ['Varegruppe', 'Hovedgruppe', 'Gruppe', 'Summeringsgruppe'];

    //
    static readonly validKey: string[] = [
        'f1',
        'f2',
        'f3',
        'f4',
        'f5',
        'f6',
        'f7',
        'f8',
        'f9',
        'f10',
        'f11',
        Utils.IS_ENV_DEV(true) ? 'esc' : 'f12',
        'ctrl + shift + f1',
        'shift + f1',
        'shift + f2',
        'shift + f3',
        'shift + f4',
        'shift + f5',
        'shift + f6',
        'shift + f7',
        'shift + f8',
        'shift + f9',
        'shift + f10',
        'shift + f11',
        'shift + f12',
        'ctrl + s',
        'ctrl + f1',
        'ctrl + f2',
        'ctrl + f3',
        'enter',
        'tab',
        'arrowleft',
        'arrowright',
        'arrowdown',
        'arrowup',
        'shift + home',
        'shift + end',
    ];
    //
    static readonly programIncludeListWithF3MenyKeyEnabled: string[] = [
        'ATL3'
        , 'BES1'
        , 'EM01'
        , 'EM03'
        , 'ENLO'
        , 'ENVE'
        , 'ETTI'
        , 'KVAP'
        , 'KVA1'
        , 'KVA2'
        , 'LAFI'
        , 'LAG4'
        , 'LAVA'
        , 'OMLO'
        , 'ROR3'
        , 'SE01'
        , 'TIL1'
        , 'TIL2'
        , 'TIL3'
        , 'TIL5'
        , 'TIL6'
        , 'TIL7'
        , 'TIL8'
        , 'VE03'
        , 'VE04'
        , 'VETT'
        , 'VARN'
        , 'VASA'
        , 'VASK'
        , 'VARA'
        , 'VARE'
        , 'ENMB'
        , 'ENMA'
        , 'LAVE'
        , 'ALT3'
        , 'UTSA'
        , 'BESK'
        , 'LAG1'
        , 'LAG9'
        , 'LOC7'
        , 'BESD'
        , 'VE00'
        , 'BES1'
        , 'BES2'
        , 'BES3'
        , 'BES6'
        , 'BES7'
        , 'BES8'
        , 'BES9'
        , 'ED01'
        , 'STY1'
    ];
    //
    static readonly programExcludeListWithF3MenyKeyDisabled: string[] = ['BES1', 'VAVE'];
    /*
    * Tell a transaction on F3 to go to a specific route
    *
    * NOTE: The previous `'VAVE': 'NV03'` mapping was removed because it forced
    * every F3 in VAVE to navigate to /NV03 regardless of which program the
    * user actually came from. Origin is now driven exclusively by
    * `ui.urlCallBack` (set by the caller, e.g. NV03), so that VALF→VAVE→F3
    * correctly returns to VALF via COBOL PF3, and NV03→VAVE→F3 returns to NV03.
    */
    static readonly transURLMapF3: Record<string, string> = {
    };

    /*
    * Return a predefined url parameter
    *
    */
    static getInputParamfromKeyPressed = (key: string) => {
        switch (key) {
            // case 'f1':
            //   return '&DFH_PF1=PF1';
            case 'f2':
                return '&DFH_PF2=PF2';
            case 'f3':
                return '&DFH_PF3=PF3';
            case 'f4':
                return '&DFH_PF4=PF4';
            case 'f5':
                return '&DFH_PF5=PF5';
            case 'f6':
                return '&DFH_PF6=PF6';
            case 'f7':
                return '&DFH_PF7=PF7';
            case 'f8':
                return '&DFH_PF8=PF8';
            case 'f9':
                return '&DFH_PF9=PF9';
            case 'f10':
                return '&DFH_PF10=PF10';
            case 'f11':
                return '&DFH_PF11=PF11';
            case 'f12':
                return '&DFH_PF12=PF12';
            case 'shift + f1':
                return '&DFH_PF13=PF13';
            case 'shift + f2':
                return '&DFH_PF14=PF14';
            case 'shift + f3':
                return '&DFH_PF15=PF15';
            case 'shift + f4':
                return '&DFH_PF16=PF16';
            case 'shift + f5':
                return '&DFH_PF17=PF17';
            case 'shift + f6':
                return '&DFH_PF18=PF18';
            case 'shift + f7':
                return '&DFH_PF19=PF19';
            case 'shift + f8':
                return '&DFH_PF20=PF20';
            case 'shift + f9':
                return '&DFH_PF21=PF21';
            case 'shift + f10':
                return '&DFH_PF22=PF22';
            case 'shift + f11':
                return '&DFH_PF23=PF23';
            case 'shift + f12':
                return '&DFH_PF24=PF24';
            case 'enter':
                return '&DFH_ENTER=Enter';
            case 'clear':
                return '&DFH_CLEAR=Clear';
            default:
                return '';
        }
    };


    /*
    * Return a predefined url parameter
    *
    */
    static lookupAndSwitchTransURL = (key: string) => {
        switch (key) {
            // case 'f1':
            //   return '&DFH_PF1=PF1';
            case 'ORKU':
                return 'NO01';
            case 'VAST':
                return 'NV01';
            case 'VARK':
                return 'NV01';
            case 'VARS':
                return 'NV01';
            case 'VAKT':
                return 'NV01';
            // case 'LAVE':
            //    return 'NV02';
            default:
                return key;
        }
    };


}



